export { DimmerWrapper as Dimmer } from './styles'
